export default "__VITE_ASSET__D6mgRz0O__"